var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('ConstantsProvider',[_c('ListsCountProvider',[_c('div',[_c('NoSSR',[_c('Experiments'),_c('LoginFlow')],1),(!_vm.hideAppHeader)?_c('AppHeader'):_vm._e(),_c('KeepAlive',[_c('RouterView')],1),_c('StyleInjector'),_c('LowPriorityComponents')],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }